import { createElementBlock as r, openBlock as o, createElementVNode as l } from "vue";
const c = { viewBox: "0 0 21 21" };
function t(n, e) {
  return o(), r("svg", c, [...e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      d: "M5.167 11.143c0-.355.298-.643.666-.643H11.7c.368 0 .667.288.667.643a.655.655 0 0 1-.667.643H5.833a.655.655 0 0 1-.666-.643m.666 1.235a.655.655 0 0 0-.666.642c0 .356.298.643.666.643h3.734a.655.655 0 0 0 .666-.643.655.655 0 0 0-.666-.642z"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.115 4.5c-.34 0-.615.298-.615.667v10.666c0 .368.276.667.615.667h14.77c.34 0 .615-.299.615-.667V5.167c0-.369-.276-.667-.615-.667zM17.27 7.929V5.833H3.731V7.93h13.538ZM3.731 9.214h13.538v5.953H3.731z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const a = { render: t };
export {
  a as default,
  t as render
};
